export default __webpack_public_path__ + "img/62c6bbfd6c1ea61cec765d4bf1032e51.svg";